import { z } from "zod";

// ============================================================================
// RETELL WEBHOOK EVENT SCHEMA
// ============================================================================

// Based on RetellWebhookEvent from types/follow-up.ts
export const RetellWebhookEventSchema = z.object({
  event_type: z.enum(["call_started", "call_ended", "call_analyzed"]),
  call: z.object({
    call_id: z.string(),
    agent_id: z.string(),
    metadata: z.record(z.string(), z.unknown()).optional(),
  }),
});

// ============================================================================
// TYPE EXPORTS
// ============================================================================

export type RetellWebhookEvent = z.infer<typeof RetellWebhookEventSchema>;
